export default __webpack_public_path__ + "static/media/cp_geo_co.616fbe2f.svg";